import { style } from '@vanilla-extract/css';
import { vars } from '@/shared/ui/theme/contract.css';

/**
 * 「이미 답한 사람 다시 넣기」 — 발송 확인의 한 칸 (퀘스트 12bcfe19).
 *
 * 확인 줄 바로 아래에 서는 보조 칸이라 상자는 한 겹이고, 명단은 자기 칸 안에서만 스크롤한다 —
 * 수백 행이 그대로 펼쳐지면 발송 버튼이 화면 밖으로 밀린다.
 */
export const card = style({
  display: 'flex',
  flexDirection: 'column',
  gap: vars.spacing.gap.sm,
  padding: vars.spacing.padding.sm,
  borderRadius: vars.spacing.borderRadius.md,
  border: `1px solid ${vars.surface.border.subtle}`,
  background: vars.surface.card.default,
});

export const head = style({
  display: 'flex',
  alignItems: 'center',
  gap: vars.spacing.gap.sm,
});

export const heading = style({
  margin: 0,
  fontSize: vars.typography.fontSize.sm,
  fontWeight: String(vars.typography.fontWeight.semibold),
  color: vars.typography.textColor.primary,
});

export const count = style({
  flexGrow: 1,
  fontSize: vars.typography.fontSize.xs,
  color: vars.typography.textColor.secondary,
});

export const note = style({
  margin: 0,
  fontSize: vars.typography.fontSize['2xs'],
  lineHeight: String(vars.typography.lineHeight.relaxed),
  color: vars.typography.textColor.tertiary,
});

export const scroll = style({
  maxHeight: 240,
  overflowY: 'auto',
});

export const rows = style({
  display: 'flex',
  flexDirection: 'column',
  gap: vars.spacing.gap.xs,
  margin: 0,
  padding: 0,
  listStyle: 'none',
});

export const row = style({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) auto auto',
  alignItems: 'center',
  gap: vars.spacing.gap.sm,
  padding: `${vars.spacing.padding.xs} ${vars.spacing.padding.sm}`,
  borderRadius: vars.spacing.borderRadius.sm,
  background: vars.surface.card.hover,
});

export const handle = style({
  fontSize: vars.typography.fontSize.xs,
  color: vars.typography.textColor.primary,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const detail = style({
  fontSize: vars.typography.fontSize['2xs'],
  color: vars.typography.textColor.tertiary,
  whiteSpace: 'nowrap',
});

export const actions = style({
  display: 'flex',
  gap: vars.spacing.gap.xs,
  justifyContent: 'flex-end',
});
